import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::index
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:28
* @route '/studio/{team}/scenarios/{scenario}/ink-errors'
*/
export const index = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/scenarios/{scenario}/ink-errors',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::index
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:28
* @route '/studio/{team}/scenarios/{scenario}/ink-errors'
*/
index.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
    }

    return index.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::index
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:28
* @route '/studio/{team}/scenarios/{scenario}/ink-errors'
*/
index.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::index
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:28
* @route '/studio/{team}/scenarios/{scenario}/ink-errors'
*/
index.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::index
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:28
* @route '/studio/{team}/scenarios/{scenario}/ink-errors'
*/
const indexForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::index
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:28
* @route '/studio/{team}/scenarios/{scenario}/ink-errors'
*/
indexForm.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::index
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:28
* @route '/studio/{team}/scenarios/{scenario}/ink-errors'
*/
indexForm.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::show
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:90
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}'
*/
export const show = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::show
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:90
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}'
*/
show.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            inkErrorGroup: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        inkErrorGroup: typeof args.inkErrorGroup === 'object'
        ? args.inkErrorGroup.id
        : args.inkErrorGroup,
    }

    return show.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{inkErrorGroup}', parsedArgs.inkErrorGroup.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::show
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:90
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}'
*/
show.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::show
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:90
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}'
*/
show.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::show
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:90
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}'
*/
const showForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::show
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:90
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}'
*/
showForm.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::show
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:90
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}'
*/
showForm.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::resolve
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:121
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/resolve'
*/
export const resolve = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolve.url(args, options),
    method: 'post',
})

resolve.definition = {
    methods: ["post"],
    url: '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/resolve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::resolve
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:121
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/resolve'
*/
resolve.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            inkErrorGroup: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        inkErrorGroup: typeof args.inkErrorGroup === 'object'
        ? args.inkErrorGroup.id
        : args.inkErrorGroup,
    }

    return resolve.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{inkErrorGroup}', parsedArgs.inkErrorGroup.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::resolve
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:121
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/resolve'
*/
resolve.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::resolve
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:121
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/resolve'
*/
const resolveForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::resolve
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:121
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/resolve'
*/
resolveForm.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, options),
    method: 'post',
})

resolve.form = resolveForm

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::ignore
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:137
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/ignore'
*/
export const ignore = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ignore.url(args, options),
    method: 'post',
})

ignore.definition = {
    methods: ["post"],
    url: '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/ignore',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::ignore
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:137
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/ignore'
*/
ignore.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            inkErrorGroup: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        inkErrorGroup: typeof args.inkErrorGroup === 'object'
        ? args.inkErrorGroup.id
        : args.inkErrorGroup,
    }

    return ignore.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{inkErrorGroup}', parsedArgs.inkErrorGroup.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::ignore
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:137
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/ignore'
*/
ignore.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ignore.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::ignore
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:137
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/ignore'
*/
const ignoreForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ignore.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::ignore
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:137
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/ignore'
*/
ignoreForm.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ignore.url(args, options),
    method: 'post',
})

ignore.form = ignoreForm

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::reopen
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:153
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/reopen'
*/
export const reopen = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reopen.url(args, options),
    method: 'post',
})

reopen.definition = {
    methods: ["post"],
    url: '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/reopen',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::reopen
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:153
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/reopen'
*/
reopen.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            inkErrorGroup: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        inkErrorGroup: typeof args.inkErrorGroup === 'object'
        ? args.inkErrorGroup.id
        : args.inkErrorGroup,
    }

    return reopen.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{inkErrorGroup}', parsedArgs.inkErrorGroup.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::reopen
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:153
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/reopen'
*/
reopen.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reopen.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::reopen
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:153
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/reopen'
*/
const reopenForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reopen.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\InkErrorGroupController::reopen
* @see Http/Controllers/Web/Studio/InkErrorGroupController.php:153
* @route '/studio/{team}/scenarios/{scenario}/ink-errors/{inkErrorGroup}/reopen'
*/
reopenForm.post = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, inkErrorGroup: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reopen.url(args, options),
    method: 'post',
})

reopen.form = reopenForm

const inkErrors = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    resolve: Object.assign(resolve, resolve),
    ignore: Object.assign(ignore, ignore),
    reopen: Object.assign(reopen, reopen),
}

export default inkErrors